import { trpc } from '@/shared/api/trpc';

// Countries that have at least one regional video assigned. Same query
// the itinerary settings page uses for its country dropdown — chapters
// reuse it so the picker stays consistent across surfaces.
export const useChapterCountries = (args: { enabled: boolean }) =>
  trpc.regionalVideos.findCountriesForItineraries.useQuery(undefined, {
    enabled: args.enabled,
  });

// Org-defined custom regions for the supplied country — the same polygon
// catalog the planner map's region picker uses. A chapter stores the
// selected region's UUID in `regionId`, and the active chapter feeds that
// UUID into the product search as `customRegionIds` (ST_Contains against the
// region's boundary geometry). This mirrors the legacy planner, where the
// chapter region IS a custom-region id — NOT a `regionalVideos` name string,
// which products cannot be filtered by. Empty / unset country leaves the
// query idle so we don't fetch the whole catalog before a country is picked.
export const useChapterRegions = (args: {
  country: string | null;
  enabled: boolean;
}) => {
  const trimmed = (args.country ?? '').trim();
  const query = trpc.customRegions.findAll.useQuery(
    { countries: [trimmed], limit: 200 },
    { enabled: args.enabled && trimmed.length > 0 }
  );
  const options = (query.data?.data ?? []).map((r) => ({
    label: r.title,
    value: r.id,
  }));
  return { ...query, options };
};

// Traveller types catalog — drives the per-chapter custom-traveller
// counter rows. Gated by `company_settings:read` server-side; callers
// without it see an empty options list and the "Custom" toggle
// renders no rows.
export const useChapterTravellerTypes = (args: { enabled: boolean }) =>
  trpc.travellerTypes.findAll.useQuery(
    { limit: 200, sort: 'title', order: 'asc' },
    { enabled: args.enabled }
  );
